import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useGeneralRefetchOverride } from "./general.queries";
import { QueryNames } from "./queries.constant";
import { getApiLanguage } from "src/services/commonLanguageHeader";
import {
  getRouteHistoryByVehicleId,
  type RouteHistoryParams,
} from "src/services/routeHistoryService";

export const useQueryGetRouteHistory = (
  params?: RouteHistoryParams,
  options: { enabled?: boolean } & Record<string, unknown> = {},
) => {
  const { i18n } = useTranslation();
  const language = getApiLanguage(i18n.language);
  const enabled =
    !!params?.vehicleId &&
    !!params.date &&
    params.startHour >= 0 &&
    params.endHour >= 0 &&
    options.enabled !== false;

  return useGeneralRefetchOverride(
    useQuery({
      queryKey: [...QueryNames.routeHistory, params, language],
      queryFn: () => getRouteHistoryByVehicleId(params as RouteHistoryParams, language),
      enabled,
      retry: false,
      ...options,
    }),
    enabled,
  );
};
